<template>
    <div id="notifications-page" class="gradbg">
        <div class="header-panel">
            <h1>Notifications</h1>
        </div>
        <div class="list-panel">
            <ul>
                <li v-for="(c, index) in config" :key="index">
                    <a href="#" @click.prevent="toggleSetting(c)" :class="{on: c.value}">
                        {{ c.label }}
                    </a>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import {mapState} from 'vuex'

export default {
    name: 'notifications',
    data() {
        return {
            config: [
                { label: 'Automatic Transfers - Text', value: false},
                { label: 'Automatic Transfers - Email', value: false},
                ],
        }
    },
    computed: {
        ...mapState(['bankInfo']),
    },
    methods: {
        toggleSetting(c) {
            c.value = !c.value
        }
    },
}
</script>
<style lang="scss">
#notifications-page {
    flex: 1 1 100%;

    display: flex;
    flex-flow: column nowrap;
    height: 100%;

    .list-panel {
        flex: 1 1 100%;
        background: white;

        ul {
            li {
                border-bottom: solid 1px #DFE2E5;
                text-align: left;

                a {
                    padding: 16px 20px;
                    display: block;
                    font-size: 13px;
                    font-weight: bold;
                    color: black;
                    text-decoration: none;

                    &.on {
                        background: url('../assets/check-solid.svg') no-repeat 95% 50% transparent;
                        background-size: 14px;
                    }
                }
            }
        }
    }
}
</style>

